import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-37" data-mp="3ogau3n1a2v3q">
      <div className="mx-auto max-w-4xl" data-id="element-38" data-mp="3oi41x5nmnldb">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-39" data-mp="3sglaltmp53wu">
          Dall’incertezza clinica alla sicurezza nel decidere durante ogni visita
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-inksoft sm:text-lg" data-id="element-40" data-mp="3jhgawjzef4j3">
          Smetti di cercare risposte tra molteplici linee guida e inizia a seguire un Percorso
          Clinico progettato per valutare, trattare e monitorare i pazienti con obesità in modo
          chiaro e basato sulle evidenze.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 sm:gap-6" data-id="element-41" data-mp="30qoytao11010">
          <div className="rounded-3xl border border-[#E7CFCB] bg-[#FDF4F3] p-5 sm:p-6" data-id="element-42" data-mp="30s02lahh27s4">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-danger/10 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.16em] text-danger" data-id="element-43" data-mp="x6n0023qenjz">
              Prima
            </p>
            <ul className="space-y-3" data-id="element-44" data-mp="170dp997on20q">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-45" data-mp="124gav8fzc5ql">
                  <span className="mt-[3px] flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-danger/15" data-id="element-46" data-mp="edaums64nbfr">
                    <XIcon className="h-3.5 w-3.5 text-danger" aria-hidden="true" data-id="element-47" data-mp="9gaoyid6wap6" />
                  </span>
                  <span className="text-[14px] font-medium leading-snug text-ink/80 sm:text-[15px]" data-id="element-48" data-mp="o5gm80sgvquf">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-brand-100 bg-brand-50 p-5 sm:p-6" data-id="element-49" data-mp="3rqm8s190zfpi">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-brand-500/15 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand-700" data-id="element-50" data-mp="3mtm51wznep1k">
              Con il Percorso Clinico
            </p>
            <ul className="space-y-3" data-id="element-51" data-mp="20giyz1dibd2r">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-52" data-mp="20iwutcg0gtbd">
                  <span className="mt-[3px] flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-500" data-id="element-53" data-mp="24h300g17b0u6">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-54" data-mp="17tpx2fods7r6" />
                  </span>
                  <span className="text-[14px] font-semibold leading-snug text-brand-900 sm:text-[15px]" data-id="element-55" data-mp="1ct2jizbcbct8">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-56" data-mp="2s88eaqrhtl2d">
          <CtaButton label="Inizio il mio Percorso Clinico oggi" note="Accesso immediato a soli €19 · Pagamento unico" data-id="element-57" data-mp="2s6xbou9sajcu" />
        </div>
      </div>
    </section>;
}